import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import TarotReadingDeckCard from './deck-card';

class Component extends BaseComponent {
    render({ spread }) {
        return (
            <tarot-reading-deck>
                {spread.map((card_id) => this.renderCard(card_id))}
            </tarot-reading-deck>
        );
    }

    renderCard = (card_id) => {
        if (card_id) {
            return (
                <TarotReadingDeckCard card_id={card_id} upsell={this.props.upsell} upc={this.props.upc} />
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    spread: state.deck && state.deck.spread,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-readings/tarot-reading/deck.js